"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZEFFY_BANNER_IMAGES = void 0;
exports.ZEFFY_BANNER_IMAGES = [
    {
        id: "9d71eb28-b4da-42b5-bef7-160f54bd2d52",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178550/zeffy-images-library/Zeffy/Square/Zeffy_Activism_1080.jpg",
        name: "activism_zeffy",
        style: "Zeffy",
        category: "Politics",
        tags: [
            "Activism",
            "Protest",
            "Group",
            "Speak up",
            "March",
            "Politique",
            "Activisme",
            "Manifestation",
            "Groupe",
            "Marche",
        ],
    },
    {
        id: "6edc4e8e-892c-499a-a427-2924862d8a0b",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178539/zeffy-images-library/Zeffy/Square/Zeffy_All_Sports_1080.jpg",
        name: "sports_zeffy",
        style: "Zeffy",
        category: "Sports",
        tags: [
            "Sports",
            "Athletic",
            "Activity",
            "Healthy",
            "Recess",
            "Sportif",
            "Activité",
            "Santé",
            "Récréation",
            "Athlétique",
        ],
    },
    {
        id: "be11c3f0-574d-4128-b75c-a37992d06590",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178542/zeffy-images-library/Zeffy/Square/Zeffy_Chalkboard_1080.jpg",
        name: "chalkboard_zeffy",
        style: "Zeffy",
        category: "School",
        tags: [
            "Chalkboard",
            "School",
            "Teacher",
            "Book",
            "Education",
            "École",
            "Professeur",
            "Livre",
            "Éducation",
            "Tableau",
        ],
    },
    {
        id: "06f89a7c-9d0e-487a-a6aa-dbe8283daf0f",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178551/zeffy-images-library/Zeffy/Square/Zeffy_Donate_1080.jpg",
        name: "gifts_zeffy",
        style: "Zeffy",
        category: "Holidays",
        tags: ["Gifts", "Presents", "Christmas", "Holiday", "Giving", "Fêtes", "Cadeaux", "Noël", "Vacances", "Don"],
    },
    {
        id: "c6e574f1-0d8c-4bc5-80b5-afff2bf4d351",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178548/zeffy-images-library/Zeffy/Square/Zeffy_Church_1080.jpg",
        name: "church_zeffy",
        style: "Zeffy",
        category: "Religion",
        tags: ["Religion", "Pray", "Christian", "Catholic", "Church", "Prière", "Chrétien", "Catholique", "Église", "Foi"],
    },
    {
        id: "d33bb740-8438-4154-bb88-f9818f31276a",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178549/zeffy-images-library/Zeffy/Square/Zeffy_Theatre_1080.jpg",
        name: "theatre_zeffy",
        style: "Zeffy",
        category: "Arts & culture",
        tags: [
            "Acting",
            "Theatre",
            "Play",
            "Drama",
            "Performance",
            "Arts",
            "Culture",
            "Arts et culture",
            "Théâtre",
            "Pièce",
            "Spectacle",
            "Comédie",
        ],
    },
    {
        id: "7a18ed68-779f-4584-b554-c1228929b42c",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178537/zeffy-images-library/Zeffy/Square/Zeffy_Christmas_1080.jpg",
        name: "holidaygifts_zeffy",
        style: "Zeffy",
        category: "Holidays",
        tags: [
            "Holiday",
            "Gifts",
            "Giving",
            "Generous",
            "Seasonal",
            "Fêtes",
            "Cadeaux",
            "Don",
            "Généreux",
            "Saisonnier",
            "Noël",
        ],
    },
    {
        id: "2cb7ed21-627f-4645-9149-62eac49e624e",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178552/zeffy-images-library/Zeffy/Square/Zeffy_Golf_1080.jpg",
        name: "golf_zeffy",
        style: "Zeffy",
        category: "Sports",
        tags: ["Golf", "Putting", "Sports", "Hobby", "Driver", "Sport", "Loisir", "Passe-temps"],
    },
    {
        id: "8633ffa7-4d6e-4050-be45-863756b91133",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178545/zeffy-images-library/Zeffy/Square/Zeffy_Trivia_1080.jpg",
        name: "trivia_zeffy",
        style: "Zeffy",
        category: "Event",
        tags: ["Trivia", "Questions", "Quiz", "Trivia Night", "Event", "Événement", "Soirée quiz", "Jeu-questionnaire"],
    },
    {
        id: "0a4b5d71-195a-44b1-b93b-78cf5bf32ece",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178544/zeffy-images-library/Zeffy/Square/Zeffy_Painting_1080.jpg",
        name: "painting_zeffy",
        style: "Zeffy",
        category: "Arts & culture",
        tags: [
            "Painting",
            "Hobbies",
            "Painter",
            "Brush",
            "Artist",
            "Arts",
            "Culture",
            "Arts et culture",
            "Peinture",
            "Artiste",
            "Pinceau",
            "Loisir",
        ],
    },
    {
        id: "0db2dcf1-ee0b-4427-8ed2-21a046d00bc4",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178540/zeffy-images-library/Zeffy/Square/Zeffy_Prayer_1080.jpg",
        name: "pray_zeffy",
        style: "Zeffy",
        category: "Religion",
        tags: ["Pray", "Religion", "Hope", "Thank you", "Healing", "Prière", "Espoir", "Merci", "Guérison", "Foi"],
    },
    {
        id: "0a83c28f-2674-49d4-9534-717729e1176c",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178547/zeffy-images-library/Zeffy/Square/Zeffy_Raffle_1080.jpg",
        name: "raffle_zeffy",
        style: "Zeffy",
        category: "Event",
        tags: ["Raffle", "Event", "50/50", "Lottery", "Winner", "Événement", "Tirage", "Loterie", "Gagnant"],
    },
    {
        id: "58310452-8c9e-494c-8b4b-7a6900794292",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178541/zeffy-images-library/Zeffy/Square/zeffy_ambulance.png",
        name: "ambulance_zeffy",
        style: "Zeffy",
        category: "Health",
        tags: [
            "Ambulance",
            "Health",
            "Service",
            "Helping",
            "Paramedics",
            "Santé",
            "Service",
            "Aide",
            "Ambulanciers",
            "Urgence",
        ],
    },
    {
        id: "6f6d82f2-2e46-497e-b079-f3ef8cd38689",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178542/zeffy-images-library/Zeffy/Square/zeffy_cats.jpg",
        name: "cats_zeffy",
        style: "Zeffy",
        category: "Animals",
        tags: [
            "Cats",
            "Animals",
            "Shelter",
            "Pets",
            "Fostering",
            "Animaux",
            "Chats",
            "Refuge",
            "Animaux de compagnie",
            "Famille d'accueil",
        ],
    },
    {
        id: "0f2bb528-5a22-4689-956a-d25a1feb7a60",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178540/zeffy-images-library/Zeffy/Square/zeffy_exoticanimals.jpg",
        name: "exoticanimals_zeffy",
        style: "Zeffy",
        category: "Animals",
        tags: [
            "Animals",
            "Pets",
            "Exotic Animals",
            "Shelter",
            "Fostering",
            "Animaux",
            "Animaux exotiques",
            "Refuge",
            "Animaux de compagnie",
        ],
    },
    {
        id: "713bc20c-cdf5-4017-9eab-334e9fdbb691",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178537/zeffy-images-library/Zeffy/Square/zeffy_firefighting.png",
        name: "firefighters_zeffy",
        style: "Zeffy",
        category: "Community",
        tags: [
            "Firefighter",
            "Fire",
            "Service Worker",
            "Helping",
            "Paramedics",
            "Communauté",
            "Pompier",
            "Feu",
            "Service",
            "Aide",
            "Secouriste",
        ],
    },
    {
        id: "5714e2fd-2f9b-47d9-a4bd-8ae4599390be",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178543/zeffy-images-library/Zeffy/Square/zeffy_fooddrive.png",
        name: "foodbox_zeffy",
        style: "Zeffy",
        category: "Food",
        tags: [
            "Food",
            "Pantry",
            "Giving",
            "Foodbank",
            "Food Drive",
            "Nourriture",
            "Alimentation",
            "Banque alimentaire",
            "Collecte alimentaire",
            "Don",
        ],
    },
    {
        id: "3a6fe3a0-990c-496c-88ef-16274d562064",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178549/zeffy-images-library/Zeffy/Square/zeffy_groceries.jpg",
        name: "groceries_zeffy",
        style: "Zeffy",
        category: "Food",
        tags: [
            "Food",
            "Pantry",
            "Groceries",
            "Giving",
            "Food Drive",
            "Nourriture",
            "Épicerie",
            "Alimentation",
            "Banque alimentaire",
            "Don",
        ],
    },
    {
        id: "e565c430-8006-46c1-a712-d2dcd2bc6f6a",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178552/zeffy-images-library/Zeffy/Square/zeffy_teamwork.png",
        name: "community_zeffy",
        style: "Zeffy",
        category: "Community",
        tags: [
            "Environment",
            "Planting",
            "Helping",
            "Community",
            "Teamwork",
            "Communauté",
            "Environnement",
            "Plantation",
            "Aide",
            "Travail d'équipe",
        ],
    },
    {
        id: "39871108-c424-4225-9092-46ef2f0f4fc0",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178538/zeffy-images-library/Zeffy/Square/zeffy_heart.png",
        name: "strong_heart_zeffy",
        style: "Zeffy",
        category: "Health",
        tags: ["Strong", "Heart", "Health", "Healthy", "Athlete", "Santé", "Cœur", "Fort", "Athlète", "Bien-être"],
    },
    {
        id: "afa66637-5a3e-46c6-826a-d9f86d2c6f26",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178546/zeffy-images-library/Zeffy/Square/Zeffy_School_1080.jpg",
        name: "schoolsupplies_zeffy",
        style: "Zeffy",
        category: "School",
        tags: ["School", "Pencils", "Book", "Education", "Math", "École", "Crayons", "Livre", "Éducation", "Mathématiques"],
    },
    {
        id: "679821f1-822e-4a3d-b558-d964038b4347",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178545/zeffy-images-library/Zeffy/Square/Zeffy_Debate_1080.jpg",
        name: "debate_zeffy",
        style: "Zeffy",
        category: "Politics",
        tags: [
            "Debate",
            "Politics",
            "Presentation",
            "Speech",
            "Speaking",
            "Politique",
            "Débat",
            "Présentation",
            "Discours",
        ],
    },
    {
        id: "b22e9303-2d3e-494b-8381-18ac398c30e5",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178442/zeffy-images-library/Collage/Square/Ambulance_Paramedics.jpg",
        name: "savinglives_collage",
        style: "Collage",
        category: "Community",
        tags: [
            "Healthcare",
            "Ambulance",
            "Paramedics",
            "Health",
            "Emergency",
            "Communauté",
            "Santé",
            "Ambulanciers",
            "Urgence",
            "Soins de santé",
        ],
    },
    {
        id: "6bb35d26-3ff9-4931-8d1a-59be6ae80fbc",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178444/zeffy-images-library/Collage/Square/Basketball.jpg",
        name: "basketball_collage",
        style: "Collage",
        category: "Sports",
        tags: ["Basketball", "Sports", "Athletics", "Athlete", "Ball", "Sport", "Athlétisme", "Athlète", "Ballon"],
    },
    {
        id: "eebceb43-fda0-4063-8fa5-da2fc148c081",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178435/zeffy-images-library/Collage/Square/Canned_Goods.jpg",
        name: "candrive_collage",
        style: "Collage",
        category: "Food",
        tags: [
            "Can Drive",
            "Food bank",
            "Giving",
            "Food",
            "Can",
            "Nourriture",
            "Alimentation",
            "Banque alimentaire",
            "Conserves",
            "Don",
        ],
    },
    {
        id: "81a113eb-1f03-4b62-8489-1a730dd02079",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178440/zeffy-images-library/Collage/Square/Concert.jpg",
        name: "concert_collage",
        style: "Collage",
        category: "Event",
        tags: ["Concert", "Music", "Singing", "Performance", "Show", "Événement", "Musique", "Chant", "Spectacle"],
    },
    {
        id: "d68a8538-b644-4e76-91e6-7675ba1024cf",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178443/zeffy-images-library/Collage/Square/Cross.jpg",
        name: "cross_collage",
        style: "Collage",
        category: "Religion",
        tags: ["Cross", "Religion", "Pray", "Jesus", "Christianity", "Croix", "Prière", "Jésus", "Christianisme", "Foi"],
    },
    {
        id: "6121f9ab-b0de-44b9-83a0-4aae6ed0d70a",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178438/zeffy-images-library/Collage/Square/DJ_set.jpg",
        name: "dj_collage",
        style: "Collage",
        category: "Arts & culture",
        tags: [
            "Dj",
            "Music",
            "Rave",
            "Club",
            "Dancing",
            "Arts",
            "Culture",
            "Arts et culture",
            "Musique",
            "Danse",
            "Soirée",
        ],
    },
    {
        id: "683f8c82-ddeb-4af0-af1f-bb91209eeda3",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178445/zeffy-images-library/Collage/Square/Dogs_only.jpg",
        name: "dogs_collage",
        style: "Collage",
        category: "Animals",
        tags: [
            "Dogs",
            "Animals",
            "Shelter",
            "Adopt",
            "Pets",
            "Animaux",
            "Chiens",
            "Refuge",
            "Adoption",
            "Animaux de compagnie",
        ],
    },
    {
        id: "f25d3069-be09-48e5-bcdc-766b515250bf",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178433/zeffy-images-library/Collage/Square/Dove_Angel.jpg",
        name: "angel_collage",
        style: "Collage",
        category: "Religion",
        tags: ["Angel", "Religion", "Valentines Day", "Love", "Pray", "Ange", "Saint-Valentin", "Amour", "Prière", "Foi"],
    },
    {
        id: "82b6a7df-635c-4339-b57e-9e66d2425f8b",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178447/zeffy-images-library/Collage/Square/Easter.jpg",
        name: "easter_collage",
        style: "Collage",
        category: "Holidays",
        tags: ["Easter", "Bunny", "Eggs", "Holiday", "Rabbit", "Fêtes", "Pâques", "Lapin", "Œufs", "Vacances"],
    },
    {
        id: "b9ca8c06-e255-4f1b-b901-e190f1d64741",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178436/zeffy-images-library/Collage/Square/First_Aid.jpg",
        name: "firstaid_collage",
        style: "Collage",
        category: "Health",
        tags: [
            "First Aid",
            "Medical Emergency",
            "Emergency Care",
            "First Responder",
            "Medical Treatment",
            "Santé",
            "Premiers soins",
            "Urgence médicale",
            "Secouriste",
            "Soins médicaux",
        ],
    },
    {
        id: "cac1bebb-2064-4230-9bd4-603ba2b4553d",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178436/zeffy-images-library/Collage/Square/Gala.jpg",
        name: "gala_collage",
        style: "Collage",
        category: "Event",
        tags: [
            "Gala Event",
            "Formal Gathering",
            "Fundraising Gala",
            "Charity Event",
            "Evening Reception",
            "Événement",
            "Gala",
            "Soirée",
            "Collecte de fonds",
            "Réception",
        ],
    },
    {
        id: "25b728c3-1f95-46d9-afe4-d343d2c457a3",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178439/zeffy-images-library/Collage/Square/Halloween.jpg",
        name: "halloween_collage",
        style: "Collage",
        category: "Holidays",
        tags: [
            "Halloween Holiday",
            "Spooky Season",
            "Costume Party",
            "Trick Or Treat",
            "October Festival",
            "Fêtes",
            "Halloween",
            "Costumes",
            "Bonbons",
            "Citrouille",
        ],
    },
    {
        id: "0993f1b2-78fe-43b4-b43d-89d6b7125e0c",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178446/zeffy-images-library/Collage/Square/Hands_up_activism.jpg",
        name: "activism_collage",
        style: "Collage",
        category: "Politics",
        tags: [
            "Social Activism",
            "Political Movement",
            "Community Organizing",
            "Advocacy",
            "Grassroots Campaign",
            "Politique",
            "Activisme",
            "Mouvement politique",
            "Plaidoyer",
            "Mobilisation",
        ],
    },
    {
        id: "510f7705-1ffa-465c-8c4f-a9ba5c776388",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178443/zeffy-images-library/Collage/Square/Mallette_Whitehouse.jpg",
        name: "whitehouse_collage",
        style: "Collage",
        category: "Politics",
        tags: [
            "White House",
            "Presidential Residence",
            "US Government",
            "Executive Office",
            "Washington DC",
            "Politique",
            "Maison Blanche",
            "Gouvernement",
            "Président",
        ],
    },
    {
        id: "799d9950-f419-406f-b18d-05f214cd5eae",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178441/zeffy-images-library/Collage/Square/Meditation_mind.jpg",
        name: "wellness_collage",
        style: "Collage",
        category: "Health",
        tags: [
            "Health Wellness",
            "Wellbeing",
            "Self Care",
            "Holistic Health",
            "Mental Wellness",
            "Santé",
            "Bien-être",
            "Soins personnels",
            "Santé mentale",
            "Méditation",
        ],
    },
    {
        id: "3da365e5-ea72-462b-b0f2-57525dd053ca",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178437/zeffy-images-library/Collage/Square/Movie_Popcorn.jpg",
        name: "movie_collage",
        style: "Collage",
        category: "Arts & culture",
        tags: [
            "Film Production",
            "Cinema",
            "Movie Theater",
            "Filmmaking",
            "Motion Picture",
            "Arts",
            "Culture",
            "Arts et culture",
            "Film",
            "Cinéma",
            "Salle de cinéma",
        ],
    },
    {
        id: "47ebed88-3b43-48d6-810f-94e539110e60",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178435/zeffy-images-library/Collage/Square/Rescuing_birds.jpg",
        name: "bird_collage",
        style: "Collage",
        category: "Animals",
        tags: [
            "Bird Species",
            "Wildlife",
            "Feathered Bird",
            "Bird Watching",
            "Flying Bird",
            "Animaux",
            "Oiseaux",
            "Faune",
            "Observation d'oiseaux",
        ],
    },
    {
        id: "8b050fa1-c842-45ec-b599-67d4b0620d4e",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178441/zeffy-images-library/Collage/Square/Run.jpg",
        name: "run_collage",
        style: "Collage",
        category: "Sports",
        tags: [
            "Running Exercise",
            "Jogging",
            "Runner Athlete",
            "Cardio Workout",
            "Distance Running",
            "Sports",
            "Course",
            "Jogging",
            "Athlète",
            "Cardio",
            "Marathon",
        ],
    },
    {
        id: "62ec6ea7-c504-47ed-bb1c-d0442c122443",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178439/zeffy-images-library/Collage/Square/Talking_Together.jpg",
        name: "talk_collage",
        style: "Collage",
        category: "Community",
        tags: [
            "Public Speaking",
            "Conversation",
            "Discussion Forum",
            "Verbal Communication",
            "Speech Presentation",
            "Communauté",
            "Discours",
            "Conversation",
            "Discussion",
            "Présentation",
        ],
    },
    {
        id: "b0c5f67d-e11b-4c19-992d-b8002dbe654a",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178446/zeffy-images-library/Collage/Square/Vegetables.jpg",
        name: "vegetables_collage",
        style: "Collage",
        category: "Food",
        tags: [
            "Fresh Vegetables",
            "Healthy Produce",
            "Vegetable Garden",
            "Nutritious Food",
            "Plant Based",
            "Nourriture",
            "Légumes",
            "Alimentation saine",
            "Potager",
            "Végétal",
        ],
    },
    {
        id: "497f093d-c286-4b65-a2c3-0e6c53584fe4",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178566/zeffy-images-library/Collage/Square/collage_backtoschool.jpg",
        name: "backtoschool_collage",
        style: "Collage",
        category: "School",
        tags: [
            "Back To School",
            "School Season",
            "Academic Year",
            "Student Life",
            "School Supplies",
            "École",
            "Rentrée scolaire",
            "Année scolaire",
            "Vie étudiante",
            "Fournitures scolaires",
        ],
    },
    {
        id: "a5a2eb31-951d-4abc-89a4-02887ea96fbe",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178565/zeffy-images-library/Collage/Square/collage_graduation.jpg.jpg",
        name: "graduates_collage",
        style: "Collage",
        category: "School",
        tags: [
            "Graduation Ceremony",
            "Graduate Student",
            "Commencement",
            "Academic Achievement",
            "Diploma Recipients",
            "École",
            "Remise de diplômes",
            "Diplômé",
            "Cérémonie",
            "Réussite académique",
        ],
    },
    {
        id: "d0bcf888-f6af-43a1-91cf-0c24eb1d0bb9",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178512/zeffy-images-library/Watercolor/Square/building.jpg",
        name: "building_watercolor",
        style: "Watercolor",
        category: "Community",
        tags: [
            "Building",
            "Workers",
            "Bricklaying",
            "House development",
            "Construction",
            "Communauté",
            "Bâtiment",
            "Travailleurs",
            "Maçonnerie",
            "Développement",
        ],
    },
    {
        id: "f6683435-3ec4-4e44-9e10-3f91886066eb",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178511/zeffy-images-library/Watercolor/Square/watercolor_gardening.jpg",
        name: "gardening_watercolor",
        style: "Watercolor",
        category: "Community",
        tags: [
            "Garden Plants",
            "Gardening Tools",
            "Plant Care",
            "Home Garden",
            "Outdoor Gardening",
            "Communauté",
            "Jardinage",
            "Plantes",
            "Outils de jardin",
            "Potager",
        ],
    },
    {
        id: "f3548238-0f57-4d63-8af5-acb83b6c76f1",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178504/zeffy-images-library/Watercolor/Square/watercolor_movie.jpg",
        name: "movie_watercolor",
        style: "Watercolor",
        category: "Arts & culture",
        tags: [
            "Film Production",
            "Cinema",
            "Movie Theater",
            "Filmmaking",
            "Motion Picture",
            "Arts",
            "Culture",
            "Arts et culture",
            "Film",
            "Cinéma",
            "Salle de cinéma",
        ],
    },
    {
        id: "100a7c23-aefe-4419-93e8-fbc319a58224",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178506/zeffy-images-library/Watercolor/Square/watercolor_bakesale.jpg",
        name: "bake_sale_watercolor",
        style: "Watercolor",
        category: "Food",
        tags: [
            "Fresh Food",
            "Healthy Eating",
            "Food Preparation",
            "Cuisine",
            "Meal Planning",
            "Nourriture",
            "Alimentation",
            "Pâtisserie",
            "Vente de gâteaux",
            "Repas",
        ],
    },
    {
        id: "dde0979e-f35c-4add-ab8e-e496298f09c8",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178502/zeffy-images-library/Watercolor/Square/watercolor_cats.jpg",
        name: "cats_watercolor",
        style: "Watercolor",
        category: "Animals",
        tags: [
            "Domestic Cat",
            "Cat Care",
            "Feline Behavior",
            "Pet Cat",
            "Cat Breeds",
            "Animaux",
            "Chat",
            "Soins des chats",
            "Animaux de compagnie",
            "Races de chats",
        ],
    },
    {
        id: "8d05bdbb-06b8-4afb-9a3f-2a7238124e92",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178505/zeffy-images-library/Watercolor/Square/dogs.jpg",
        name: "dogs_watercolor",
        style: "Watercolor",
        category: "Animals",
        tags: [
            "Domestic Dog",
            "Dog Care",
            "Canine Companion",
            "Pet Dog",
            "Dog Breeds",
            "Animaux",
            "Chien",
            "Soins des chiens",
            "Animaux de compagnie",
            "Races de chiens",
        ],
    },
    {
        id: "2ceb7b2a-7443-42b0-91b3-d8cf7aff79a4",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178519/zeffy-images-library/Watercolor/Square/watercolor_bookworm.jpg",
        name: "book_worm_watercolor",
        style: "Watercolor",
        category: "School",
        tags: [
            "Book Lover",
            "Reading Enthusiast",
            "Avid Reader",
            "Literary Passion",
            "Bookworm",
            "École",
            "Lecture",
            "Livres",
            "Rat de bibliothèque",
            "Passion littéraire",
        ],
    },
    {
        id: "e0787715-a7c3-47c7-b7c4-cf0209203523",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178516/zeffy-images-library/Watercolor/Square/watercolor_backpack.jpg",
        name: "backpack_watercolor",
        style: "Watercolor",
        category: "School",
        tags: [
            "Travel Backpack",
            "School Bag",
            "Backpack Design",
            "Hiking Backpack",
            "Rucksack",
            "École",
            "Sac à dos",
            "Sac d'école",
            "Randonnée",
        ],
    },
    {
        id: "737437fc-c1c2-4d18-aaf9-0ab74a5981bb",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178516/zeffy-images-library/Watercolor/Square/watercolor_dinnerparty.jpg",
        name: "apero_watercolor",
        style: "Watercolor",
        category: "Food",
        tags: [
            "Apero",
            "Aperitif Hour",
            "French Tradition",
            "Pre-Dinner Drinks",
            "Social Gathering",
            "Nourriture",
            "Apéro",
            "Tradition française",
            "Rassemblement social",
            "Soirée",
        ],
    },
    {
        id: "c1b55b6c-a595-4011-937e-8e69d3d2a4e3",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178509/zeffy-images-library/Watercolor/Square/watercolor_karaoke.jpg",
        name: "karaoke_watercolor",
        style: "Watercolor",
        category: "Arts & culture",
        tags: [
            "Karaoke Night",
            "Singing Entertainment",
            "Karaoke Bar",
            "Music Performance",
            "Vocal Entertainment",
            "Arts",
            "Culture",
            "Arts et culture",
            "Karaoké",
            "Soirée karaoké",
            "Musique",
            "Chant",
        ],
    },
    {
        id: "5f734ae6-da69-49e6-b5c6-98556faa2eb1",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178511/zeffy-images-library/Watercolor/Square/watercolor_fruits.jpg",
        name: "fruits_watercolor",
        style: "Watercolor",
        category: "Food",
        tags: [
            "Fresh Fruit",
            "Fruit Variety",
            "Healthy Produce",
            "Fruit Selection",
            "Tropical Fruits",
            "Nourriture",
            "Fruits",
            "Fruits frais",
            "Produits sains",
            "Fruits tropicaux",
        ],
    },
    {
        id: "4ebebe93-5191-454a-ab1c-633c1c20864b",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178514/zeffy-images-library/Watercolor/Square/watercolor_hospital.jpg",
        name: "hospital_watercolor",
        style: "Watercolor",
        category: "Health",
        tags: [
            "Medical Facility",
            "Hospital Care",
            "Healthcare Center",
            "Medical Treatment",
            "Patient Care",
            "Santé",
            "Hôpital",
            "Centre médical",
            "Soins de santé",
            "Soins aux patients",
        ],
    },
    {
        id: "19ada211-5eaa-49b8-982f-fe19b06b6038",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178508/zeffy-images-library/Watercolor/Square/watercolor_doctors.jpg",
        name: "doctors_watercolor",
        style: "Watercolor",
        category: "Health",
        tags: [
            "Medical Doctor",
            "Healthcare Professional",
            "Physician Care",
            "Medical Practitioner",
            "Doctor Patient",
            "Santé",
            "Médecin",
            "Professionnel de santé",
            "Docteur",
            "Soins médicaux",
        ],
    },
    {
        id: "b6533e77-65f8-46c0-af22-6bac6f2ea03e",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178515/zeffy-images-library/Watercolor/Square/watercolor_mothersday.jpg",
        name: "mothers_watercolor",
        style: "Watercolor",
        category: "Holidays",
        tags: [
            "Motherhood",
            "Mother Child",
            "Maternal Love",
            "Mom Life",
            "Parenting",
            "Fêtes",
            "Fête des mères",
            "Maternité",
            "Amour maternel",
            "Parentalité",
        ],
    },
    {
        id: "815934b8-842b-491d-8d2c-02d90659cb73",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178513/zeffy-images-library/Watercolor/Square/watercolor_christmastree.jpg",
        name: "christmas_watercolor",
        style: "Watercolor",
        category: "Holidays",
        tags: [
            "Christmas Holiday",
            "Festive Season",
            "Holiday Celebration",
            "Christmas Tradition",
            "Winter Festival",
            "Fêtes",
            "Noël",
            "Saison festive",
            "Célébration",
            "Tradition de Noël",
        ],
    },
    {
        id: "95cc0c82-8069-4b51-83d6-530e46ad0a83",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178505/zeffy-images-library/Watercolor/Square/watercolor_voteca.jpg",
        name: "canada_vote_watercolor",
        style: "Watercolor",
        category: "Politics",
        tags: [
            "Canadian Election",
            "Voting Rights",
            "Democratic Process",
            "Electoral Participation",
            "Civic Duty",
            "Politique",
            "Élection canadienne",
            "Droit de vote",
            "Démocratie",
            "Participation électorale",
        ],
    },
    {
        id: "f2732d35-6235-4717-aa6e-767a0979bad1",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178517/zeffy-images-library/Watercolor/Square/watercolor_hindu.jpg",
        name: "hinduism_watercolor",
        style: "Watercolor",
        category: "Religion",
        tags: [
            "Hindu Religion",
            "Hinduism Practice",
            "Hindu Tradition",
            "Spiritual Belief",
            "Hindu Culture",
            "Religion",
            "Hindouisme",
            "Tradition hindoue",
            "Croyance spirituelle",
            "Culture hindoue",
        ],
    },
    {
        id: "9a07638c-cf13-4681-9f14-347bb79d3452",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178503/zeffy-images-library/Watercolor/Square/watercolor_faith.jpg",
        name: "faith_watercolor",
        style: "Watercolor",
        category: "Religion",
        tags: [
            "Religious Faith",
            "Spiritual Belief",
            "Faith Practice",
            "Devotion",
            "Belief System",
            "Religion",
            "Foi",
            "Croyance spirituelle",
            "Dévotion",
            "Spiritualité",
        ],
    },
    {
        id: "3dfdcb73-c92b-49b5-8b13-2243f47c81ff",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178520/zeffy-images-library/Watercolor/Square/watercolor_voteus.jpg",
        name: "vote_US_watercolor",
        style: "Watercolor",
        category: "Politics",
        tags: [
            "US Election",
            "American Voting",
            "Ballot Box",
            "Electoral Process",
            "Democracy",
            "Politique",
            "Élection américaine",
            "Vote",
            "Urne",
            "Démocratie",
        ],
    },
    {
        id: "3d2242dd-3612-4b41-965b-d88f95f30230",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178508/zeffy-images-library/Watercolor/Square/watercolor_softball.jpg",
        name: "softball_watercolor",
        style: "Watercolor",
        category: "Sports",
        tags: [
            "Softball Game",
            "Softball Player",
            "Team Sport",
            "Softball League",
            "Fastpitch Softball",
            "Sports",
            "Balle molle",
            "Sport d'équipe",
            "Ligue de softball",
        ],
    },
    {
        id: "149b0ca6-b8e6-4604-a836-d5f07e91a94a",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178518/zeffy-images-library/Watercolor/Square/watercolor_painting.jpg",
        name: "painting_watercolor",
        style: "Watercolor",
        category: "Arts & culture",
        tags: [
            "Art Painting",
            "Fine Art",
            "Canvas Art",
            "Artistic Expression",
            "Paint Artwork",
            "Arts",
            "Culture",
            "Arts et culture",
            "Peinture",
            "Beaux-arts",
            "Toile",
            "Expression artistique",
        ],
    },
    {
        id: "5e4ef8fe-0d7e-4c9d-8ffe-5febfa1f67ca",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178501/zeffy-images-library/Watercolor/Square/watercolor_running.jpg",
        name: "running_watercolor",
        style: "Watercolor",
        category: "Sports",
        tags: [
            "Running Exercise",
            "Jogging",
            "Runner Athlete",
            "Cardio Workout",
            "Distance Running",
            "Sports",
            "Course",
            "Jogging",
            "Athlète",
            "Cardio",
            "Marathon",
        ],
    },
    {
        id: "1b588957-510d-445f-ab03-b77e02c5a9b1",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178479/zeffy-images-library/Retro/Square/activism.jpg",
        name: "environment_retro",
        style: "Retro",
        category: "Politics",
        tags: [
            "Natural Environment",
            "Environmental Protection",
            "Ecosystem",
            "Sustainability",
            "Nature Conservation",
            "Politique",
            "Environnement",
            "Protection de l'environnement",
            "Écosystème",
            "Durabilité",
        ],
    },
    {
        id: "47d8aebb-ab67-4d5b-8546-b4bd5dda031b",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178476/zeffy-images-library/Retro/Square/baseball.jpg",
        name: "home_run_retro",
        style: "Retro",
        category: "Sports",
        tags: [
            "Baseball Homer",
            "Home Run Hit",
            "Grand Slam",
            "Baseball Achievement",
            "Batting Success",
            "Sports",
            "Baseball",
            "Coup de circuit",
            "Batte",
        ],
    },
    {
        id: "a487faab-3a82-4047-b2f3-35882ceb4550",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178470/zeffy-images-library/Retro/Square/bible_and_cross.jpg",
        name: "cross_retro",
        style: "Retro",
        category: "Religion",
        tags: [
            "Christian Cross",
            "Religious Symbol",
            "Faith Icon",
            "Crucifix",
            "Spiritual Symbol",
            "Religion",
            "Croix chrétienne",
            "Symbole religieux",
            "Foi",
            "Crucifix",
            "Spiritualité",
        ],
    },
    {
        id: "fb54f8ce-1d8d-4b21-a7fc-2853a0d1d4fd",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178469/zeffy-images-library/Retro/Square/bird.jpg",
        name: "bird_retro",
        style: "Retro",
        category: "Animals",
        tags: [
            "Bird Species",
            "Avian Wildlife",
            "Feathered Bird",
            "Bird Watching",
            "Flying Bird",
            "Animaux",
            "Oiseaux",
            "Faune aviaire",
            "Observation d'oiseaux",
        ],
    },
    {
        id: "ded6d55d-acb0-4f2a-a791-aa27f4853310",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178471/zeffy-images-library/Retro/Square/book_theme.jpg",
        name: "book_retro",
        style: "Retro",
        category: "School",
        tags: [
            "Book Reading",
            "Literature",
            "Published Book",
            "Novel",
            "Reading Material",
            "École",
            "Lecture",
            "Littérature",
            "Livre",
            "Roman",
        ],
    },
    {
        id: "a34b9a06-ab75-4324-bc41-40bec9076bda",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178480/zeffy-images-library/Retro/Square/car_wash.jpg",
        name: "car_wash_retro",
        style: "Retro",
        category: "Event",
        tags: [
            "Car Cleaning",
            "Vehicle Wash",
            "Auto Detailing",
            "Car Care",
            "Wash Service",
            "Événement",
            "Lavage auto",
            "Nettoyage de voiture",
            "Entretien auto",
        ],
    },
    {
        id: "af03ff9a-f531-4ab6-9834-87ce63a66bec",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178465/zeffy-images-library/Retro/Square/dog_and_cat.jpg",
        name: "dog_retro",
        style: "Retro",
        category: "Animals",
        tags: [
            "Domestic Dog",
            "Dog Care",
            "Canine Companion",
            "Pet Dog",
            "Dog Breeds",
            "Animaux",
            "Chien",
            "Soins des chiens",
            "Animaux de compagnie",
            "Races de chiens",
        ],
    },
    {
        id: "42444ad4-563b-4c34-9643-ad46c34625ff",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178472/zeffy-images-library/Retro/Square/father_s_day.jpg",
        name: "father's_day_retro",
        style: "Retro",
        category: "Holidays",
        tags: [
            "Fathers Day",
            "Dad Celebration",
            "Paternal Love",
            "Father Appreciation",
            "Fatherhood",
            "Fêtes",
            "Fête des pères",
            "Papa",
            "Amour paternel",
            "Paternité",
        ],
    },
    {
        id: "6065526f-82a6-4d34-9adb-9bebfde9f341",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178477/zeffy-images-library/Retro/Square/firefighter.jpg",
        name: "fire_fighters_retro",
        style: "Retro",
        category: "Community",
        tags: [
            "Firefighter",
            "Fire Department",
            "Emergency Responder",
            "Fire Brigade",
            "Rescue Service",
            "Communauté",
            "Pompier",
            "Caserne de pompiers",
            "Secouriste",
            "Service de secours",
        ],
    },
    {
        id: "5e97970d-700c-4f17-94d5-b454978fa8ab",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178475/zeffy-images-library/Retro/Square/handshake.jpg",
        name: "flower_retro",
        style: "Retro",
        category: "Community",
        tags: [
            "Blooming Flower",
            "Floral Design",
            "Garden Bloom",
            "Botanical Beauty",
            "Flower Arrangement",
            "Communauté",
            "Fleur",
            "Design floral",
            "Jardin",
            "Arrangement floral",
        ],
    },
    {
        id: "28eddd7d-be51-4846-be6b-0a054e2abcce",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178473/zeffy-images-library/Retro/Square/heart.jpg",
        name: "heart_doctor_retro",
        style: "Retro",
        category: "Health",
        tags: [
            "Cardiologist",
            "Heart Specialist",
            "Cardiac Care",
            "Heart Health",
            "Cardiovascular Medicine",
            "Santé",
            "Cardiologue",
            "Spécialiste du cœur",
            "Soins cardiaques",
            "Médecine cardiovasculaire",
        ],
    },
    {
        id: "a3809c8e-3a84-4c86-93be-9d3a6d43f59a",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178480/zeffy-images-library/Retro/Square/mental_health.jpg",
        name: "idea_retro",
        style: "Retro",
        category: "Health",
        tags: [
            "Creative Idea",
            "Innovation",
            "Brainstorming",
            "Inspiration",
            "Concept Development",
            "Santé",
            "Idée créative",
            "Innovation",
            "Remue-méninges",
            "Inspiration",
        ],
    },
    {
        id: "5ca6efa0-aec5-45b1-969a-dc280468567b",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178469/zeffy-images-library/Retro/Square/movie_night.jpg",
        name: "movie_retro",
        style: "Retro",
        category: "Event",
        tags: [
            "Film Production",
            "Cinema",
            "Movie Theater",
            "Filmmaking",
            "Motion Picture",
            "Événement",
            "Film",
            "Cinéma",
            "Salle de cinéma",
            "Soirée cinéma",
        ],
    },
    {
        id: "87b551e8-7452-42d4-870d-74e18628aaab",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178468/zeffy-images-library/Retro/Square/number.jpg",
        name: "calculator_retro",
        style: "Retro",
        category: "School",
        tags: [
            "Math Calculator",
            "Computing Device",
            "Calculation Tool",
            "Mathematical Instrument",
            "Digital Calculator",
            "École",
            "Calculatrice",
            "Mathématiques",
            "Outil de calcul",
        ],
    },
    {
        id: "d9b1485f-53bf-45c6-9082-463359defba9",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178474/zeffy-images-library/Retro/Square/pancake.jpg",
        name: "pancake_retro",
        style: "Retro",
        category: "Food",
        tags: [
            "Pancake Breakfast",
            "Breakfast Food",
            "Flapjacks",
            "Pancake Stack",
            "Morning Meal",
            "Nourriture",
            "Crêpes",
            "Petit-déjeuner",
            "Repas du matin",
        ],
    },
    {
        id: "3b38d251-1efe-49b4-a1f3-5c2c181db00c",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178478/zeffy-images-library/Retro/Square/pizza.jpg",
        name: "pizza_party_retro",
        style: "Retro",
        category: "Food",
        tags: [
            "Pizza Celebration",
            "Party Food",
            "Pizza Gathering",
            "Social Event",
            "Group Meal",
            "Nourriture",
            "Pizza",
            "Fête",
            "Rassemblement",
            "Repas de groupe",
        ],
    },
    {
        id: "ae3ed7e9-f074-40e3-8cba-c94b3c7bcf18",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178472/zeffy-images-library/Retro/Square/soccer.jpg",
        name: "soccer_retro",
        style: "Retro",
        category: "Sports",
        tags: [
            "Soccer Game",
            "Football Sport",
            "Soccer Player",
            "Soccer Match",
            "Team Sport",
            "Sports",
            "Soccer",
            "Football",
            "Joueur de soccer",
            "Sport d'équipe",
        ],
    },
    {
        id: "a7246716-e540-4c28-ad03-012ef68d3079",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178479/zeffy-images-library/Retro/Square/star_of_david.jpg",
        name: "judaism_retro",
        style: "Retro",
        category: "Religion",
        tags: [
            "Jewish Religion",
            "Judaism Practice",
            "Jewish Tradition",
            "Hebrew Faith",
            "Jewish Culture",
            "Religion",
            "Judaïsme",
            "Tradition juive",
            "Foi hébraïque",
            "Culture juive",
        ],
    },
    {
        id: "cf4d3977-1efd-449b-8963-c5cd344df452",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178467/zeffy-images-library/Retro/Square/thanksgiving.jpg",
        name: "thanksgiving_retro",
        style: "Retro",
        category: "Holidays",
        tags: [
            "Thanksgiving Holiday",
            "Harvest Celebration",
            "Gratitude Feast",
            "Family Gathering",
            "Turkey Day",
            "Fêtes",
            "Action de grâce",
            "Récolte",
            "Rassemblement familial",
            "Dinde",
        ],
    },
    {
        id: "a1bfc474-0599-4684-9574-73f7eea2d122",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178467/zeffy-images-library/Retro/Square/theatre.jpg",
        name: "dancing_retro",
        style: "Retro",
        category: "Arts & culture",
        tags: [
            "Dance Performance",
            "Dancing Art",
            "Choreography",
            "Dance Movement",
            "Social Dancing",
            "Arts",
            "Culture",
            "Arts et culture",
            "Danse",
            "Chorégraphie",
            "Spectacle de danse",
        ],
    },
    {
        id: "9e25b160-edee-4d39-99a2-dedccb0ed755",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1766178466/zeffy-images-library/Retro/Square/vote.jpg",
        name: "vote_retro",
        style: "Retro",
        category: "Politics",
        tags: [
            "Voting Rights",
            "Electoral Process",
            "Democratic Participation",
            "Ballot Casting",
            "Civic Engagement",
            "Politique",
            "Droit de vote",
            "Processus électoral",
            "Participation démocratique",
            "Engagement civique",
        ],
    },
    {
        id: "ae122664-fe30-4466-ae8c-22c6a385580a",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1768936781/zeffy-images-library/Vibrant/Square/vibrant_square_auction.png",
        name: "auction_vibrant",
        style: "Vibrant",
        category: "Event",
        tags: [
            "Auction",
            "Silent Auction",
            "Event",
            "Bid",
            "Bidder",
            "Vente aux enchères",
            "Vente aux enchères silencieuse",
            "Vente aux enchères en ligne",
            "Vente aux enchères en direct",
            "Vente aux enchères en temps réel",
            "Vente aux enchères en direct",
        ],
    },
    {
        id: "63bd1e9b-3ea7-498b-9ab4-5a4c4ad86d13",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1768936781/zeffy-images-library/Vibrant/Square/vibrant_square_breastcancer.png",
        name: "breastcancer_vibrant",
        style: "Vibrant",
        category: "Health",
        tags: [
            "Health",
            "Breast Cancer",
            "Cancer",
            "Sickness",
            "Awareness",
            "Cancer",
            "Santé",
            "Conscience",
            "Maladie",
            "Conscience",
        ],
    },
    {
        id: "f1a135ac-7131-438b-bef4-0499639556c6",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1768936781/zeffy-images-library/Vibrant/Square/vibrant_square_catsanddogs.png",
        name: "catsanddogs_vibrant",
        style: "Vibrant",
        category: "Animals",
        tags: [
            "Cats",
            "Dogs",
            "Adopt",
            "Animals",
            "Shelter",
            "Chats",
            "Chiens",
            "Adoption",
            "Refuge",
            "Animaux de compagnie",
            "Animaux de compagnie",
        ],
    },
    {
        id: "4e3c6d39-ffdd-4de0-9808-51a7efc2858c",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1768936782/zeffy-images-library/Vibrant/Square/vibrant_square_classroomelements.png",
        name: "classroomelements_vibrant",
        style: "Vibrant",
        category: "School",
        tags: [
            "Classroom",
            "School",
            "Education",
            "Pencil",
            "Learn",
            "École",
            "Professeur",
            "Livre",
            "Éducation",
            "Tableau",
        ],
    },
    {
        id: "8af84147-e3e3-4683-97c5-9621922361c8",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1768936782/zeffy-images-library/Vibrant/Square/vibrant_square_doctor.png",
        name: "doctor_vibrant",
        style: "Vibrant",
        category: "Health",
        tags: [
            "Doctor",
            "Healthcare",
            "Health Professional",
            "Treatment",
            "Care",
            "Médecin",
            "Santé",
            "Soins",
            "Traitement",
            "Soins médicaux",
        ],
    },
    {
        id: "4a841953-ef1e-4304-b444-f7c7ef75b7e9",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1768936781/zeffy-images-library/Vibrant/Square/vibrant_square_farmanimals.png",
        name: "farmanimals_vibrant",
        style: "Vibrant",
        category: "Animals",
        tags: ["Farm Animals", "Animals", "Pets", "Farming", "Shelter", "Animaux de ferme", "Animaux de ferme"],
    },
    {
        id: "88243e24-17c1-4371-9aca-52d44ea77448",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1768936782/zeffy-images-library/Vibrant/Square/vibrant_square_gala.png",
        name: "gala_vibrant",
        style: "Vibrant",
        category: "Event",
        tags: ["Gala", "Event", "Party", "Evening", "Dinner", "Fête", "Rassemblement", "Repas de groupe"],
    },
    {
        id: "8e5c018a-7f22-4900-8c2c-56f4ea0602c8",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1768936783/zeffy-images-library/Vibrant/Square/vibrant_square_givingaboxoffood.png",
        name: "givingboxoffood_vibrant",
        style: "Vibrant",
        category: "Food",
        tags: [
            "Giving",
            "Food",
            "Sharing",
            "Food box",
            "Groceries",
            "Don",
            "Alimentation",
            "Épicerie",
            "Banque alimentaire",
        ],
    },
    {
        id: "f0961184-c8d7-4bb7-9364-f4304452948d",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1768936783/zeffy-images-library/Vibrant/Square/vibrant_square_golf.png",
        name: "golf_vibrant",
        style: "Vibrant",
        category: "Sports",
        tags: ["Golf", "Sport", "Golf Tournament", "Golfer", "Putting"],
    },
    {
        id: "5e74cd52-b63c-4f9b-9757-094146a0a34f",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1768936783/zeffy-images-library/Vibrant/Square/vibrant_square_grocerybags.png",
        name: "grocerybags_vibrant",
        style: "Vibrant",
        category: "Food",
        tags: ["Thank You", "Flowers", "Thankful", "Gift", "Food", "Épicerie", "Alimentation", "Banque alimentaire", "Don"],
    },
    {
        id: "fb17a66b-5080-4666-aa58-f8fe2a71788e",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1768936784/zeffy-images-library/Vibrant/Square/vibrant_square_instruments.png",
        name: "instruments_vibrant",
        style: "Vibrant",
        category: "Arts & culture",
        tags: ["Instruments", "Music", "Dancing", "Singing", "Theatre", "Musique", "Danse", "Spectacle", "Théâtre"],
    },
    {
        id: "569c99bf-35ff-4964-a4ca-21f59c88fc84",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1768936784/zeffy-images-library/Vibrant/Square/vibrant_square_Islamicsymbols.png",
        name: "islamicsymbols_vibrant",
        style: "Vibrant",
        category: "Religion",
        tags: ["Islamic", "Religion", "Islam", "Crescent", "Pray", "Islam", "Prier"],
    },
    {
        id: "46a9e84f-ab7f-4e2e-bf32-7b45b325025e",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1768936784/zeffy-images-library/Vibrant/Square/vibrant_square_jewishsymbols.png",
        name: "jewishsymbols_vibrant",
        style: "Vibrant",
        category: "Religion",
        tags: [
            "Jewish",
            "Religion",
            "Star of David",
            "Pray",
            "Hanukkah",
            "Judaïsme",
            "Tradition juive",
            "Foi juive",
            "Culture juive",
        ],
    },
    {
        id: "cc28ca1f-e4b5-4ea4-87b9-74bd1139d26b",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1768936785/zeffy-images-library/Vibrant/Square/vibrant_square_newyears.png",
        name: "newyears_vibrant",
        style: "Vibrant",
        category: "Holidays",
        tags: ["New Years", "Celebration", "Party", "Dance", "Together", "Fête", "Rassemblement", "Repas de groupe"],
    },
    {
        id: "70c61565-3ce4-474f-baf0-f5b8083c0746",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1768936785/zeffy-images-library/Vibrant/Square/vibrant_square_pencils.png",
        name: "pencils_vibrant",
        style: "Vibrant",
        category: "School",
        tags: [
            "School",
            "Pencils",
            "Education",
            "Writing",
            "Learning",
            "École",
            "Professeur",
            "Livre",
            "Éducation",
            "Tableau",
        ],
    },
    {
        id: "2f8d26d6-366d-4d2e-95a4-e8c999fa55da",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1768936785/zeffy-images-library/Vibrant/Square/vibrant_square_pickleball.png",
        name: "pickleball_vibrant",
        style: "Vibrant",
        category: "Sports",
        tags: ["Pickleball", "Tennis", "Racket", "Sport", "Team", "Équipe", "Équipe de tennis"],
    },
    {
        id: "26ae0c4a-2b79-411e-91a8-f68341ae8efd",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1768936786/zeffy-images-library/Vibrant/Square/vibrant_square_plantingtrees.png",
        name: "plantingtrees_vibrant",
        style: "Vibrant",
        category: "Community",
        tags: ["Planting Trees", "Community Service", "Environment", "Green", "Planet", "Planète", "Environnement"],
    },
    {
        id: "b3da3b6d-082c-40d2-afc2-9d0e2088c6f1",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1768936786/zeffy-images-library/Vibrant/Square/vibrant_square_publicspeaker.png",
        name: "publicspeaker_vibrant",
        style: "Vibrant",
        category: "Politics",
        tags: ["Public Speaker", "Speech", "Politics", "Debate", "Presentation", "Politique", "Débat"],
    },
    {
        id: "631b3fc1-3887-44ba-ae7c-912f2e78fa9b",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1768936787/zeffy-images-library/Vibrant/Square/vibrant_square_qancingtomusic.png",
        name: "dancingtomusic_vibrant",
        style: "Vibrant",
        category: "Arts & culture",
        tags: [
            "Dancing",
            "Music",
            "Party",
            "Together",
            "Gathering",
            "Danse",
            "Musique",
            "Fête",
            "Rassemblement",
            "Repas de groupe",
        ],
    },
    {
        id: "930af8dc-8056-415b-95c1-f94887e8f2ba",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1768936787/zeffy-images-library/Vibrant/Square/vibrant_square_trashcleanup.png",
        name: "trashcleanup_vibrant",
        style: "Vibrant",
        category: "Community",
        tags: [
            "Community Service",
            "Trash",
            "Environment",
            "Cleanup",
            "Green",
            "Planète",
            "Environnement",
            "Nettoyage",
            "Nettoyage de la nature",
        ],
    },
    {
        id: "c2f18ffb-18b6-4f40-b06e-d1c741711afd",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1768936788/zeffy-images-library/Vibrant/Square/vibrant_square_valentinesday.png",
        name: "valentinesday_vibrant",
        style: "Vibrant",
        category: "Holidays",
        tags: ["Valentines Day", "Love", "Heart", "Holiday", "Celebrate", "Fête", "Rassemblement", "Repas de groupe"],
    },
    {
        id: "4e64c4fa-2046-4162-a29f-1f2ccc8d5df1",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1768936788/zeffy-images-library/Vibrant/Square/vibrant_square_vote.png",
        name: "vote_vibrant",
        style: "Vibrant",
        category: "Politics",
        tags: ["Vote", "Politics", "Freedom", "Voice", "Ballot", "Politique", "Débat", "Présentation"],
    },
    {
        id: "f8ea8734-5bbd-48e8-9258-56f9ead5b800",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1778075817/zeffy-images-library/Zeffy/Square/Zeffy_Auction_1080.png",
        name: "auction_zeffy",
        style: "Zeffy",
        category: "Event",
        tags: ["Auction", "Bidding", "Event", "Gala", "Fundraiser", "Encan", "Enchères", "Événement", "Gala", "Collecte"],
    },
    {
        id: "e533615e-f376-46f3-a868-e3876eed8cd4",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1778075818/zeffy-images-library/Zeffy/Square/Zeffy_Auction2_1080.png",
        name: "auction2_zeffy",
        style: "Zeffy",
        category: "Event",
        tags: ["Auction", "Bidding", "Event", "Gala", "Fundraiser", "Encan", "Enchères", "Événement", "Gala", "Collecte"],
    },
    {
        id: "66efc200-1861-4d19-b429-9a2065f4aea6",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1778075820/zeffy-images-library/Zeffy/Square/Zeffy_Donation_1080.png",
        name: "donation_zeffy",
        style: "Zeffy",
        category: "Community",
        tags: ["Donation", "Giving", "Generosity", "Cause", "Support", "Don", "Générosité", "Cause", "Soutien", "Aide"],
    },
    {
        id: "b9b78b4e-9ad0-4cdd-8e49-ae44fe3af941",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1778075821/zeffy-images-library/Zeffy/Square/Zeffy_Donation2_1080.png",
        name: "donation2_zeffy",
        style: "Zeffy",
        category: "Community",
        tags: ["Donation", "Giving", "Generosity", "Cause", "Support", "Don", "Générosité", "Cause", "Soutien", "Aide"],
    },
    {
        id: "67c62759-ccb1-4175-9c63-c2098cd88f0c",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1778075823/zeffy-images-library/Zeffy/Square/Zeffy_Donation3_1080.png",
        name: "donation3_zeffy",
        style: "Zeffy",
        category: "Community",
        tags: ["Donation", "Giving", "Generosity", "Cause", "Support", "Don", "Générosité", "Cause", "Soutien", "Aide"],
    },
    {
        id: "b0641c32-e7ce-4363-b1a8-02e546e0765c",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1778075824/zeffy-images-library/Zeffy/Square/Zeffy_Gala_1080.png",
        name: "gala_zeffy",
        style: "Zeffy",
        category: "Event",
        tags: [
            "Gala",
            "Event",
            "Celebration",
            "Cocktail",
            "Evening",
            "Gala",
            "Événement",
            "Célébration",
            "Cocktail",
            "Soirée",
        ],
    },
    {
        id: "29ff575f-a247-40c0-942d-89a2f768223c",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1778075826/zeffy-images-library/Zeffy/Square/Zeffy_Membership_1080.png",
        name: "membership_zeffy",
        style: "Zeffy",
        category: "Community",
        tags: [
            "Membership",
            "Member",
            "Card",
            "Subscription",
            "Community",
            "Adhésion",
            "Membre",
            "Carte",
            "Abonnement",
            "Communauté",
        ],
    },
    {
        id: "1bb24b96-dc53-44f2-88a8-1c225714bfb6",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1778075828/zeffy-images-library/Zeffy/Square/Zeffy_Membership2_1080.png",
        name: "membership2_zeffy",
        style: "Zeffy",
        category: "Community",
        tags: [
            "Membership",
            "Member",
            "Card",
            "Subscription",
            "Community",
            "Adhésion",
            "Membre",
            "Carte",
            "Abonnement",
            "Communauté",
        ],
    },
    {
        id: "c1609749-5362-4309-b433-c15bd0afa0d8",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1778075829/zeffy-images-library/Zeffy/Square/Zeffy_Membership2_FR_1080.png",
        name: "membership2_fr_zeffy",
        style: "Zeffy",
        category: "Community",
        tags: [
            "Membership",
            "Member",
            "Card",
            "Subscription",
            "Community",
            "Adhésion",
            "Membre",
            "Carte",
            "Abonnement",
            "Communauté",
        ],
    },
    {
        id: "0caa69b3-c7a3-40b1-a73e-7f833051cf16",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1778075831/zeffy-images-library/Zeffy/Square/Zeffy_P2P_1080.png",
        name: "p2p_zeffy",
        style: "Zeffy",
        category: "Community",
        tags: [
            "Peer to peer",
            "Fundraising",
            "Community",
            "Run",
            "Team",
            "Collecte",
            "Pair à pair",
            "Communauté",
            "Course",
            "Équipe",
        ],
    },
    {
        id: "b4593578-c007-4da8-8250-d93dfce4ea15",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1778075833/zeffy-images-library/Zeffy/Square/Zeffy_P2P2_1080.png",
        name: "p2p2_zeffy",
        style: "Zeffy",
        category: "Community",
        tags: [
            "Peer to peer",
            "Fundraising",
            "Community",
            "Run",
            "Team",
            "Collecte",
            "Pair à pair",
            "Communauté",
            "Course",
            "Équipe",
        ],
    },
    {
        id: "9b3e95b2-b729-4fa1-8d0e-b714d7c709a7",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1778075834/zeffy-images-library/Zeffy/Square/Zeffy_Raffle_Form_1080.png",
        name: "raffle_form_zeffy",
        style: "Zeffy",
        category: "Event",
        tags: ["Raffle", "Lottery", "Tickets", "Prize", "Winner", "Tirage", "Loterie", "Billets", "Prix", "Gagnant"],
    },
    {
        id: "edd3644a-d38b-4636-8d94-df164ff15ee6",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1778075836/zeffy-images-library/Zeffy/Square/Zeffy_Raffle_Form2_1080.png",
        name: "raffle_form2_zeffy",
        style: "Zeffy",
        category: "Event",
        tags: ["Raffle", "Lottery", "Tickets", "Prize", "Winner", "Tirage", "Loterie", "Billets", "Prix", "Gagnant"],
    },
    {
        id: "efbfc599-d21a-4b11-aeb1-7a1c7c5b20f6",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1778075838/zeffy-images-library/Zeffy/Square/Zeffy_Raffle_Form_FR_1080.png",
        name: "raffle_form_fr_zeffy",
        style: "Zeffy",
        category: "Event",
        tags: ["Raffle", "Lottery", "Tickets", "Prize", "Winner", "Tirage", "Loterie", "Billets", "Prix", "Gagnant"],
    },
    {
        id: "a365b7f8-214b-418f-a294-9720000f1218",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1778075839/zeffy-images-library/Zeffy/Square/Zeffy_Shop_1080.png",
        name: "shop_zeffy",
        style: "Zeffy",
        category: "Community",
        tags: [
            "Shop",
            "Merchandise",
            "Store",
            "Boutique",
            "Items",
            "Boutique",
            "Marchandise",
            "Magasin",
            "Articles",
            "Vente",
        ],
    },
    {
        id: "ffd1dbd2-1d02-49ed-b427-11517769a140",
        url: "https://res.cloudinary.com/hxn9dbuhd/image/upload/v1778075841/zeffy-images-library/Zeffy/Square/Zeffy_Shop2_1080.png",
        name: "shop2_zeffy",
        style: "Zeffy",
        category: "Community",
        tags: [
            "Shop",
            "Merchandise",
            "Store",
            "Boutique",
            "Items",
            "Boutique",
            "Marchandise",
            "Magasin",
            "Articles",
            "Vente",
        ],
    },
];
